import { useSelector } from 'react-redux';

export const useProjectStateData = (projectId, stateId = 'default', prop, defaultPropValue) => {
  const data = useSelector((state) => state.firestore.data[`${projectId}.${stateId}`] || {});
  if (prop) {
    return data[prop] || defaultPropValue;
  }
  return data;
};
